"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
var addons_1 = require("@storybook/addons");
var core_events_1 = require("@storybook/core-events");
var addon_actions_1 = require("@storybook/addon-actions");
var ActionLogger_1 = require("../../components/ActionLogger");
var safeDeepEqual = function (a, b) {
    try {
        return fast_deep_equal_1.default(a, b);
    }
    catch (e) {
        return false;
    }
};
var ActionLogger = /** @class */ (function (_super) {
    __extends(ActionLogger, _super);
    function ActionLogger(props) {
        var _this = _super.call(this, props) || this;
        _this.channel = addons_1.addons.getChannel();
        _this.handleStoryChange = function () {
            var actions = _this.state.actions;
            if (actions.length > 0 && actions[0].options.clearOnStoryChange) {
                _this.clearActions();
            }
        };
        _this.addAction = function (action) {
            _this.setState(function (prevState) {
                var actions = __spreadArrays(prevState.actions);
                var previous = actions.length && actions[0];
                if (previous && safeDeepEqual(previous.data, action.data)) {
                    previous.count++; // eslint-disable-line
                }
                else {
                    action.count = 1; // eslint-disable-line
                    actions.unshift(action);
                }
                return { actions: actions.slice(0, action.options.limit) };
            });
        };
        _this.clearActions = function () {
            _this.setState({ actions: [] });
        };
        _this.state = { actions: [] };
        return _this;
    }
    ActionLogger.prototype.componentDidMount = function () {
        this.channel.addListener(addon_actions_1.EVENT_ID, this.addAction);
        this.channel.addListener(core_events_1.SELECT_STORY, this.handleStoryChange);
    };
    ActionLogger.prototype.componentWillUnmount = function () {
        this.channel.removeListener(core_events_1.SELECT_STORY, this.handleStoryChange);
        this.channel.removeListener(addon_actions_1.EVENT_ID, this.addAction);
    };
    ActionLogger.prototype.render = function () {
        var _a = this.state.actions, actions = _a === void 0 ? [] : _a;
        var active = this.props.active;
        var props = {
            actions: actions,
            onClear: this.clearActions,
        };
        return active ? react_1.default.createElement(ActionLogger_1.ActionLogger, __assign({}, props)) : null;
    };
    return ActionLogger;
}(react_1.Component));
exports.default = ActionLogger;
